var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card h-100"},[_c('div',{staticClass:"p-3 card-body"},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"pt-3 chart"},[_c('canvas',{staticClass:"chart-canvas",attrs:{"id":_vm.id,"height":_vm.height}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }